export default __webpack_public_path__ + "static/media/dutchgot-screenshot-04.4ee958fd.png";